import useSWR from 'swr'

import { FetchError } from '../../../data/fetchError'
import { FetchResponse } from '../../../data/fetchResponse'
import { FetchResult } from '../../../data/fetchResult'
import { fetchJson } from '../../../data/fetchers'
import {
  DespatchAdvice,
  DespatchAdviceItem,
  WebEdiDto,
} from '../../../data/models'
import { useConfigContext } from '../../ui-config'

// Warning pulling (refreshInterval) causes high costs in Azure!
// This was activated to show the user current data to test it
// but this needs to be replaced with optimistic UI with SignalR in the future,
// see ticket AN05873-230.

export function useAllDespatchAdvices(): FetchResult<
  WebEdiDto<DespatchAdvice>[]
> {
  const { pollingConfig } = useConfigContext()
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<WebEdiDto<DespatchAdvice>[]>,
    FetchError
  >(`/DespatchAdvices`, fetchJson<WebEdiDto<DespatchAdvice>[]>, {
    refreshInterval: pollingConfig.intervalInSeconds * 1000,
  })

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function useDespatchAdviceById(
  despatchAdviceId: string,
): FetchResult<WebEdiDto<DespatchAdvice>> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<WebEdiDto<DespatchAdvice>>,
    FetchError
  >(
    `/DespatchAdvices/${despatchAdviceId}`,
    fetchJson<WebEdiDto<DespatchAdvice>>,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function useAllDespatchAdviceItems(
  despatchAdviceId: string,
): FetchResult<DespatchAdviceItem[]> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<DespatchAdviceItem[]>,
    FetchError
  >(
    `/DespatchAdvices/${despatchAdviceId}/Items`,
    fetchJson<DespatchAdviceItem[]>,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function useDespatchAdviceItemById(
  despatchAdviceId: string,
  itemId: string,
): FetchResult<DespatchAdviceItem> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<DespatchAdviceItem>,
    FetchError
  >(
    `/DespatchAdvices/${despatchAdviceId}/Items/${itemId}`,
    fetchJson<DespatchAdviceItem>,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
